if (!customElements.get('beam-bundle-cards')) {
  customElements.define('beam-bundle-cards', class extends HTMLElement {
    connectedCallback() {
      this.scope = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.select = this.scope.querySelectorAll('variant-selects select')[Number(this.dataset.optionIndex)];
      if (!this.select) return;
      this.select.closest('.product-form__input').classList.add('beam-bundle-native-hidden');
      this.onChange = (event) => {
        if (event.target.matches(`input[name="beam-bundle-${this.dataset.section}"]`)) {
          this.select.value = event.target.value;
          this.select.dispatchEvent(new Event('change', {bubbles: true}));
        }
        this.sync();
      };
      this.scope.addEventListener('change', this.onChange);
      this.sync();
      const chooseFeatured = () => {
        if (!this.isConnected || new URLSearchParams(location.search).has('variant')) return;
        const featured = [...this.select.options].find(option => option.value.startsWith('2 Sets'));
        if (featured && !featured.disabled) {
          this.select.value = featured.value;
          this.select.dispatchEvent(new Event('change', {bubbles: true}));
        }
      };
      if (document.readyState === 'complete') chooseFeatured();
      else window.addEventListener('load', chooseFeatured, {once: true});
    }
    disconnectedCallback() { this.scope?.removeEventListener('change', this.onChange); }
    sync() {
      const cards = [...this.querySelectorAll('.beam-bundle-card')];
      const active = cards.find(card => card.dataset.value === this.select.value);
      cards.forEach(card => { card.querySelector('input').checked = card === active; });
      const picker = this.scope.querySelector('variant-selects');
      const slot = active?.querySelector('.beam-bundle-designs');
      if (slot && picker && picker.parentElement !== slot) slot.prepend(picker);
      const designs = this.scope.querySelector('beam-set-choices');
      if (active && designs && designs.parentElement !== active.querySelector('.beam-bundle-designs')) {
        active.querySelector('.beam-bundle-designs').append(designs);
      }
    }
  });
}
